export function dailyGameCopy (eligibility, config, game) {
  const response = eligibility || {}
  const settings = config || {}
  const policy = settings.eligibility || {}
  const basis = response.basis || policy.basis || 'net'
  const period = response.period || policy.period || 'yesterday'
  const minimums = [response.requiredAmount, response.requiredCashback, policy.minimumAmount, game === 'spin' ? 500 : 1000]
  const minimum = minimums.find(value => typeof value === 'number' && Number.isFinite(value) && value > 0)
  const label = `${basis === 'deposit' ? 'ยอดฝาก' : 'ยอดสุทธิ'}${period === 'today' ? 'วันนี้' : 'เมื่อวาน'}`
  const description = typeof response.description === 'string' ? response.description : typeof settings.description === 'string' ? settings.description : ''
  const remaining = typeof response.remaining === 'number' && Number.isFinite(response.remaining) ? Math.max(0, response.remaining) : minimum
  return {
    label,
    rule: `${label}ครบ ${minimum.toLocaleString('th-TH', { maximumFractionDigits: 2 })} บาท`,
    description: description.slice(0, 1000),
    missing: `${label}ยังขาดอีก ${remaining.toLocaleString('th-TH', { maximumFractionDigits: 2 })} บาท`
  }
}
